export const BASE_URLS = {
  SOURCES_INFO: '/cloudSources/sources/info',
  SOURCES_VALIDATE: '/cloudSources/sources/validate',
};
